import { Button, NonIdealState, Spinner, Tabs } from '@blueprintjs/core';
import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';

import * as api from 'api';
import { View, viewAuthorizedRoles } from '../constants';

import ClimbersTable from 'components/Registration/ClimbersTable';
import JudgesTable from 'components/Registration/JudgesTable';
import RouteNumbersTable from 'components/Registration/RouteNumbersTable';
import styles from 'components/Registration/styles.module.scss';
import { useAppSelector } from 'hooks';
import ClubsTable from 'components/Registration/ClubsTable';

export default function RegistrationView() {
  const role = useAppSelector((state) => state.general.role);

  const [selectedTab, setSelectedTab] = useState('climbers-and-clubs');

  if (!role) {
    return <NonIdealState icon={<Spinner />} />;
  }

  if (!viewAuthorizedRoles[View.grading].includes(role)) {
    return <Navigate to={'/'} />;
  }

  return (
    <Tabs
      renderActiveTabPanelOnly
      selectedTabId={selectedTab}
      onChange={(tabId) => setSelectedTab(tabId as string)}
      className={styles.tabs}
    >
      <Tabs.Tab
        id="climbers-and-clubs"
        title="Climbers & clubs"
        panel={
          <div className={styles.container}>
            <ClimbersTable />
            <ClubsTable />
          </div>
        }
      />
      <Tabs.Tab
        id="judges"
        title="Judges"
        panel={
          <div className={styles.container}>
            <JudgesTable />
          </div>
        }
      />
      <Tabs.Tab
        id="routes"
        title="Routes & categories"
        panel={<RouteNumbersTable />}
      />
      <Tabs.Tab
        id="export"
        title="Export results"
        panel={
          <div className={styles.container}>
            <a href={api.exportUrl()}>
              <Button icon="download" intent="primary">
                Export current results
              </Button>
            </a>
          </div>
        }
      />
    </Tabs>
  );
}
